import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  constructor(
    private apollo: Apollo
  ) { }

  doQuery(graphqlQuery: string, variables?: Record<string, unknown>) {
    return this.apollo.use('admin').query({
      query: gql`${graphqlQuery}`,
      variables,
      fetchPolicy: 'no-cache',
    });
  }

  doMutate(graphqlMutation: string, variables?: Record<string, unknown>) {
    return this.apollo.use('admin').mutate({
      mutation: gql`${graphqlMutation}`,
      variables,
    });
  }
}
